export type ConnectionStatus = 'connected' | 'connecting' | 'disconnected' | 'error' | 'fallback' | 'basic';

export type MessageSource = 'gateway' | 'fallback';

// Must match equa-server gateway-streaming command-center context allowlist.
export const COMMAND_CENTER_GATEWAY_ORGANIZATION = 'global';

export interface GatewayHealthResponse {
  connected: boolean;
  authOk: boolean;
  gatewayVersion?: string;
  error?: string;
}

export interface GatewayChatRequest {
  organization: string;
  message: string;
  sessionKey?: string;
  taskId?: string;
  history?: Array<{ role: string; content: string }>;
}

export interface GatewayChatResponse {
  type: 'text' | 'error' | 'tool_executing' | 'confirmation_required';
  message?: { role: string; content: string };
  error?: string;
  isAuthError?: boolean;
  executingSteps?: Array<{ toolName: string; status: string }>;
  pendingAction?: {
    id: string;
    tool: string;
    arguments: Record<string, unknown>;
    description: string;
  };
  metadata?: {
    sessionKey: string;
    source: string;
  };
}

export interface GatewayToolInvokeRequest {
  organization: string;
  toolName: string;
  args?: Record<string, unknown>;
}

export interface SSEEvent {
  event: string;
  data: any;
}

export interface GatewayConnectionState {
  connected: boolean;
  authOk: boolean;
  error?: string;
  retryCount: number;
  lastCheck?: Date;
}
